import Vue from 'vue'
import App from '@/App.vue'
import * as filters from '@/filters'

import Logo from '@/components/Logo.vue'
import Menu from '@/components/Menu.vue'
import SideBar from '@/components/SideBar.vue'

import store from '@/store'
import router from '@/router'
import i18n from '@/lang'

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'

import '@/assets/custom-theme/index.scss'
import SvgIcon from 'vue-svgicon'

import '@/assets/style.scss'
Vue.component('todo-logo', Logo)
Vue.component('todo-menu', Menu)

Vue.component('todo-side-bar', SideBar)

Vue.use(ElementUI, { locale })

Vue.use(SvgIcon, {
  tagName: 'svg-icon'
})

// Register global filter functions
Object.keys(filters).forEach(key => {
  Vue.filter(key, (filters as { [key: string ]: Function })[key])
})

Vue.config.productionTip = false
Vue.prototype.$r = router

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
